import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-small-aside-layout',
  templateUrl: './small-aside-layout.component.html',
  styleUrls: ['./small-aside-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallAsideLayoutComponent {
  @Input() hideAsideOnBreakpoint: boolean;
  @Input() rightAside: boolean;
}
